import type { FormEvent } from 'react';

type Props = {
  disabled?: boolean;
  onReset: (e: FormEvent) => void;
  /** Hide the orange «Очистить» button (legacy promo-actions has only «Найти»). */
  hideReset?: boolean;
};

/** "Очистить" / "Найти" buttons; "Найти" submits the surrounding form. */
export const FilterActions = ({ disabled, onReset, hideReset }: Props) => (
  <>
    {!hideReset && (
      <>
        <button type="button" className="btn btn-warning" onClick={onReset} disabled={disabled}>
          Очистить
        </button>{' '}
      </>
    )}
    <button type="submit" className="btn btn-primary" disabled={disabled}>
      Найти
    </button>
  </>
);
